import { jsx as _jsx } from "react/jsx-runtime";
import { Text } from '@dixa/lib-shared-habla';
import { useFormContext, useWatch } from 'react-hook-form';
import { HookFormSelectionListSingle } from 'components/hookForm';
import { ElevionLeafFieldID } from 'utils/elevion';
import { customAttributeTypeAttributes } from '../../../../../../../../../utils/customAttributeTypeAttributes';
import { renderItemOrList } from '../renderItemOrList';
function getAttributeLabelByValue(value, items) {
    for (const item of items) {
        if (item.value === value) {
            return item.title;
        }
        if ('items' in item) {
            return getAttributeLabelByValue(value, item.items);
        }
    }
    return value;
}
export const LeafFieldField = ({ parentName, customFields, }) => {
    // TODO: [TEAMS-13693] remove omit after updating to RHF v8
    const { control } = useFormContext();
    const fieldName = `${parentName}.field`;
    const identifier = useWatch({
        control,
        name: 'identifier',
    });
    const mapCustomFieldToSelect = (field) => ({
        value: `custom__${field.identifier}`,
        title: field.label,
        icon: customAttributeTypeAttributes[field.type].icon,
        // When editing a field, the field being edited should not be an option for the visibility condition
        // Because it would be a circular reference, we still display the field (disabled) as it makes for better UX
        disabled: field.identifier === identifier,
        tooltip: field.identifier === identifier ? 'This field is being edited' : '',
    });
    const selectItems = [
        {
            title: 'Custom attributes',
            items: [...customFields.map(mapCustomFieldToSelect)],
            icon: 'input',
        },
        { value: ElevionLeafFieldID.Queue, title: 'Queue', icon: 'flow' },
    ];
    return (_jsx(HookFormSelectionListSingle, Object.assign({ name: fieldName, control: control, noLabel: true, noAlert: true, componentProps: {
            getItemTitleByValue: (value) => {
                return (_jsx(Text.Paragraph, { children: getAttributeLabelByValue(value, selectItems) }));
            },
            placeholder: 'Select a field',
            dropdownProps: {
                style: {
                    width: 'auto',
                    minWidth: '200px',
                },
            },
        } }, { children: selectItems.map(renderItemOrList) })));
};
